import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcHeart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "10",
    fill: "none",
    viewBox: "0 0 12 10",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.267.753c1.372-1.135 3.15-.906 4.33.151C6.775-.154 8.533-.369 9.923.75c1.5 1.207 1.684 3.274.524 4.719-.603.75-2.003 2.034-3.079 2.988l-.005.004-1.45 1.247H5.91a.456.456 0 0 1-.437.105.5.5 0 0 1-.141-.068c-.019-.014-.037-.03-.043-.035l-.001-.001-1.46-1.25-.004-.002C2.75 7.502 1.35 6.219.746 5.468c-1.164-1.45-.948-3.5.52-4.715",
    clipRule: "evenodd"
  }));
}
var IcHeart = createNolIcon(/*#__PURE__*/forwardRef(SvgIcHeart));

export { IcHeart as I };
